<template>
  <ZtLink
    :to="home"
    data-testid="logo"
    class="text-prose font-bold leading-[0.8] tablet:hover:opacity-80"
    @click="trackClick"
  >
    <div
      class="relative grid whitespace-nowrap pb-[0.25em] grid-cols-1 grid-rows-1"
    >
      <Transition name="logo">
        <div
          :key="top"
          class="col-start-1 row-start-1"
          :style="{
            color: `rgb(var(--color-${color}) / 1)`,
          }"
        >
          {{ top }},
        </div>
      </Transition>
    </div>
    <div
      class="text-scheme-invert logo-theme-bottom [.has-hero-image_&]:text-white tablet:!text-scheme-invert"
    >
      <div>{{ bottom }}</div>
    </div>
  </ZtLink>
</template>

<script lang="ts" setup>
defineProps<{
  top: string
  color: string
  bottom: string
}>()

const emit = defineEmits(['click'])

const language = useCurrentLanguage()
const { trackEvent } = useAnalytics()

function trackClick() {
  trackEvent({
    event: 'click_navbar_element',
    element_name: 'Motto',
    element_id: 'brand-logo',
    element_url: 'home',
  })
  emit('click')
}

const home = computed(() => '/' + language.value)
</script>

<style lang="postcss">
.logo-enter-active,
.logo-leave-active {
  @apply transition duration-[400ms];
  transition-timing-function: cubic-bezier(0.92, 0.14, 0.37, 1);
}

.logo-enter-from {
  @apply translate-y-[0.75em];
  opacity: 0;
}

.logo-leave-to {
  @apply translate-y-[-0.75em];
  opacity: 0;
}
</style>
